import React from 'react'

import { Container } from '../../../Container'
import { CustomDropdown } from '../CustomDropdown'

export const CustomBuilder = ({
    details,
    formData,
    getInputProps,
    getRootProps,
    backdrop,
    setBackdrop,
    getDataShown,
    setGetDataShown,
    savedMessage,
    loading,
    saveLoading,
    handleGetData,
    retrievedData,
    handleChange,
    handlePackagingBuilder,
    handleSavePackagingBuilder,
}) => {
    return (
        <div className='relative builder'>
            {backdrop && <div className='backdrop' onClick={()=> {
                setBackdrop(false);
                setGetDataShown(false)
            }}></div>}
            {savedMessage &&  <p className='absolute text-center bold text-successful-message' style={{
                        top: '10px',
                        left: '50%',
                        zIndex: '20',
                        padding: '15px 10px',
                        margin: '0 auto',
                        width: '50%',
                        backgroundColor: 'var(--primary-white-star)',
                        borderRadius: '5px',
                        transform: 'translateX(-50%)'
                    }}>Thank you for contacting us!</p>}
            <Container>
                <div className='cart'>
                    <div className='flex justify-end'>
                        <button type='button' className='relative' onClick={handleGetData}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-shopping-cart"><circle cx="9" cy="21" r="1"></circle><circle cx="20" cy="21" r="1"></circle><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path></svg>
                            <div className='absolute top-0 right-0'>{retrievedData !== null ? retrievedData.length:''}</div>    
                        </button>
                    </div>
                </div>
                <div className='get-content'>
                    {getDataShown && (
                        <div className='data-shown'>
                            <h3>Orders Summary</h3>
                            {retrievedData ? (
                                <div className='inner-content'>
                                    {retrievedData.length !== 0 ? retrievedData.map((item, index) => (
                                        <div key={index} className='item'>
                                            <div className='grid col-3-8 col-1-md'>
                                                <img src={item.DownloadDielineImage} alt={item.DownloadDieline || 'Dieline Media'} />
                                                <div>
                                                    <p className='mb-0'>Quantity: {item.Quantity}</p>
                                                    <p className='mb-0'>Dieline: {item.DownloadDieline}</p>
                                                    {item.FileUrl && <a href={item.FileUrl}>Atttachment</a>}
                                                </div>
                                            </div>
                                            
                                        </div>
                                    )): <div>No Data</div>}
                                </div>
                            ) : (
                                <p>Loading data...</p>
                            )}
                            {retrievedData.length !== 0 && (
                                <div className='flex justify-end'>
                                    <button type='button' onClick={handlePackagingBuilder}>{loading ? 'loading..':'Submit Design'}</button>
                                </div>
                            )}
                        </div>
                    )}
                </div>
                <form onSubmit={handlePackagingBuilder}>
                    <div className='form-content'>
                        <div className='grid col-5 col-1-md w-full gap-15'>
                            <div className="form-field">
                                <label htmlFor="name" className="block pr-10">Name</label>
                                <input type="text" name="name" value={formData.name} onChange={handleChange} required />
                            </div>
                            <div className="form-field">
                                <label htmlFor="phone" className="block pr-10">Phone</label>
                                <input type="text" name="phone" value={formData.phone} onChange={handleChange} required />
                            </div>
                            <div className="form-field">
                                <label htmlFor="email" className="block pr-10">Email</label>
                                <input type="email" name="email" value={formData.email} onChange={handleChange} required />
                            </div>
                            <div className="form-field">
                                <label htmlFor="company" className="block pr-10">Company</label>
                                <input type="text" name="company" value={formData.company} onChange={handleChange} required />
                            </div>
                            <div className="form-field">
                                <label htmlFor="location" className="block pr-10">Location</label>
                                <input type="text" name="location" value={formData.location} onChange={handleChange} required />
                            </div>
                        </div>
                        <div className='grid col-4 col-1-md w-full gap-15'>
                            <div className="form-field">
                                <label htmlFor="quantity" className="block pr-10">Quantity of Bags</label>
                                <CustomDropdown
                                    show={false}
                                    options={[{val:'2000'}, {val:'4000'}, {val:'6000'}, {val:'8000'}]}
                                    name="quantity"
                                    value={formData.quantity}
                                    onChange={handleChange}
                                />
                            </div>
                            <div className="form-field">
                                <label htmlFor="downloadDieline" className="block pr-10">Dieline</label>
                                <CustomDropdown
                                    show={true}
                                    options={details}
                                    name="downloadDieline"
                                    value={formData.downloadDieline}
                                    onChange={handleChange}
                                />
                            </div>
                            <div className='form-field'>
                                <label htmlFor="file" className="block pr-10">Upload File</label>
                                <div {...getRootProps({ className: 'dropzone' })}>
                                    <input {...getInputProps()} name="file" />
                                    <p className='mb-5 bold'>{formData.file ? `${formData.file.name}` : `Drag 'n' drop some files, or click to select files`}</p>
                                </div>
                                <p className='bold text-white text-note'>(AI, and SVG format only. File size should not surpass 15 MB per document.)</p>
                                <div className='action'>
                                    <button type='button' onClick={handleSavePackagingBuilder}>{saveLoading ? 'Loading..':'Add to cart'}</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </Container>
        </div>
    )
}